<ng-template #avatarTemplate>
  <ng-content select="zelis-avatar"></ng-content>
</ng-template>

<ng-template #buttonTemplate>
  <ng-content select="zelis-button"></ng-content>
</ng-template>

<ng-template #rightIconTemplate>
  <div class="w-6 h-6 text-palette-m3-system-gray-35" *ngIf="rightIcon">
    <ng-content select="[zelisExpansionPanelRightIcon]"></ng-content>
  </div>
</ng-template>

<div class="flex items-center" *ngIf="avatar">
  <div data-cy="expansion-panel-header-content-avatar" class="mr-4">
    <ng-container *ngTemplateOutlet="avatarTemplate"></ng-container>
  </div>
</div>

<div class="flex-1 flex flex-col">
  <div class="mat-expansion-panel-header-title">
    <h5
      data-cy="expansion-panel-header-content-title"
      class="dls-body-1-semibold"
    >
      {{ title }}
    </h5>
  </div>

  <div *ngIf="description" class="mat-expansion-panel-header-description">
    <div
      data-cy="expansion-panel-header-content-description"
      class="text-base font-normal text-palette-m3-system-gray-35"
    >
      {{ description }}
    </div>
  </div>
</div>

<div *ngIf="button || rightIcon" class="flex items-center">
  <div
    data-cy="expansion-panel-header-content-button"
    class="mr-4"
    *ngIf="button"
  >
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </div>

  <div class="mr-4" *ngIf="rightIcon">
    <ng-container *ngTemplateOutlet="rightIconTemplate"></ng-container>
  </div>
</div>
